import { FEATURE_OBLIGATION_ALWAYS, FEATURE_OBLIGATION_TO_SELECT } from '@auxiliary/constants';

export const ITEM_FEATURE_SELECTOR = '[data-feature-item]';
export const ITEM_PARENT_FEATURE_SELECTOR = '[data-feature-parent]';
export const REQUIRED_TYPE_ALWAYS_SELECTOR = `[data-required-type="${FEATURE_OBLIGATION_ALWAYS}"]`;
export const REQUIRED_TYPE_TO_SELECT_SELECTOR = `[data-required-type="${FEATURE_OBLIGATION_TO_SELECT}"]`;
